import { gql } from '@apollo/client';

export const CHECK_PICKUP_ROUTE_ZIPCODE_CONFLICT = gql`
  query CheckPickupRouteZipcodeConflict($warehouseId: Long!, $zipcodes: [String!]!, $excludeRouteId: Long, $routeName: String) {
    checkPickupRouteZipcodeConflict(warehouseId: $warehouseId, zipcodes: $zipcodes, excludeRouteId: $excludeRouteId, routeName: $routeName) {
      hasConflict
      conflictingRoutes {
        id
        routeName
        zipcodesListJson
      }
      conflictingZipcodes
      conflictDetails {
        routeId
        routeName
        conflictingZipcode
      }
      hasNameConflict
      conflictingRouteNames
      invalidWarehouseZipcodes
      hasWarehouseValidationConflict
    }
  }
`;

export interface PickupRouteZipcodeConflictResponse {
  checkPickupRouteZipcodeConflict: {
    hasConflict: boolean;
    conflictingRoutes: Array<{
      id: number;
      routeName: string;
      zipcodesListJson: string;
    }>;
    conflictingZipcodes: string[];
    conflictDetails: Array<{
      routeId: number;
      routeName: string;
      conflictingZipcode: string;
    }>;
    hasNameConflict: boolean;
    conflictingRouteNames: string[];
    invalidWarehouseZipcodes: string[];
    hasWarehouseValidationConflict: boolean;
  };
}

export interface PickupRouteZipcodeConflictVariables {
  warehouseId: number;
  zipcodes: string[];
  excludeRouteId?: number;
  routeName?: string;
}
